import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface ProgressIndicatorProps {
  className?: string;
}

export const ProgressIndicator = ({ className }: ProgressIndicatorProps) => {
  return (
    <div className={cn("flex h-screen items-center justify-center bg-system-obsidian", className)}>
      <Loader2 className="h-8 w-8 animate-spin text-system-primary" />
    </div>
  );
};
